import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelledSectionAriaLabel: {
    defaultMessage: 'Cancelled section',
    description: 'Aria label for the section with a message informing the user that the shipment has been cancelled',
    id: '/W+wCr',
  },
  cancelledSectionHeader: {
    defaultMessage: 'This shipment is Cancelled',
    description: 'Header for a section informing the user that the shipment has been cancelled',
    id: 'Tw+JoS',
  },
  cancelledSectionContent: {
    defaultMessage: 'Click Restore to move this shipment into Awaiting Shipment',
    description: 'Text explaining how to restore a shipment that has been cancelled',
    id: 'VtDoxT',
  },
});
